export default "__VITE_ASSET__CW4a5aVw__"